import type { FC } from "react";
import React from "react";
import { useFlow } from "@edreamsodigeo/frontend-core";

import { LightboxRevampDesktop } from "./LightboxRevampDesktop";
import { LightboxRevampMobile } from "./LightboxRevampMobile";
import useGetSubscriptionOffers from "~/clientState/hooks/useGetSubscriptionOffers";
import {
  SubscriptionOfferPeriod,
  SubscriptionOfferType,
} from "~/generated/graphql";
import { useFilterOfferByType } from "~/clientState/hooks/useFilterOfferByType";
import { freeTrialDays } from "~/tools/subscriptionUtils";
import type { DrawerProps } from "./contracts";
import { TrustpilotProvider } from "~/clientState/providers/TrustpilotProvider";

const LightboxRevamp: FC<DrawerProps> = () => {
  const flow = useFlow();
  const isMobile = flow === "mobile";

  const { offers } = useGetSubscriptionOffers({
    offerPeriod: SubscriptionOfferPeriod.FreeTrial,
  });

  const basicOffer = useFilterOfferByType({
    offersList: offers,
    subscriptionOfferType: SubscriptionOfferType.Basic,
  });
  const plusOffer = useFilterOfferByType({
    offersList: offers,
    subscriptionOfferType: SubscriptionOfferType.Plus,
  });

  const freeTrialDaysNumber = freeTrialDays(basicOffer?.duration);

  return (
    <TrustpilotProvider>
      {isMobile ? (
        <LightboxRevampMobile
          basicOffer={basicOffer}
          plusOffer={plusOffer}
          freeTrialDays={freeTrialDaysNumber}
        />
      ) : (
        <LightboxRevampDesktop
          basicOffer={basicOffer}
          plusOffer={plusOffer}
          freeTrialDays={freeTrialDaysNumber}
        />
      )}
    </TrustpilotProvider>
  );
};

export default LightboxRevamp;
